var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC9l\\xE9ments",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icones/Autre/Question/Full/Rouge",
    className: "st0-fill",
    fill: "#EF3340"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7734,11.4199 C13.4844,11.6329 13.0004,12.0839 13.0004,12.7369 L13.0004,12.9999 C13.0004,13.5529 12.5524,13.9999 12.0004,13.9999 C11.4474,13.9999 11.0004,13.5529 11.0004,12.9999 L11.0004,12.7369 C11.0004,11.6159 11.5804,10.5479 12.5904,9.8079 C12.8504,9.6169 13.0004,9.3219 13.0004,8.9999 C13.0004,8.4479 12.5514,7.9999 12.0004,7.9999 C11.4484,7.9999 11.0004,8.4479 11.0004,8.9999 C11.0004,9.5529 10.5524,9.9999 10.0004,9.9999 C9.4474,9.9999 9.0004,9.5529 9.0004,8.9999 C9.0004,7.3459 10.3454,5.9999 12.0004,5.9999 C13.6544,5.9999 15.0004,7.3459 15.0004,8.9999 C15.0004,9.9509 14.5414,10.8569 13.7734,11.4199 L13.7734,11.4199 Z M12.0004,16.9999 C11.4474,16.9999 11.0004,16.5529 11.0004,15.9999 C11.0004,15.4469 11.4474,14.9999 12.0004,14.9999 C12.5524,14.9999 13.0004,15.4469 13.0004,15.9999 C13.0004,16.5529 12.5524,16.9999 12.0004,16.9999 L12.0004,16.9999 Z M19.8214,15.6949 C20.5684,14.4569 21.0004,13.0269 21.0004,11.4999 C21.0004,6.8059 16.9704,2.9999 12.0004,2.9999 C7.0294,2.9999 3.0004,6.8059 3.0004,11.4999 C3.0004,16.1939 7.0294,19.9999 12.0004,19.9999 C13.3254,19.9999 14.5794,19.7229 15.7114,19.2369 L19.3244,20.4409 C20.0614,20.6879 20.7854,20.0349 20.6174,19.2749 L19.8214,15.6949 Z",
    id: "Fill-1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionRed);
export default __webpack_public_path__ + "static/media/question_red.cb0636ce8448f6f5f1cd75723693c047.svg";
export { ForwardRef as ReactComponent };